import { createFileRoute } from "@tanstack/react-router";

import QuestEntryPanel from "@/components/QuestEntries/QuestEntryPanel";

const Component = () => {
  const { questUuid, entryUuid } = Route.useParams();
  // Keyed so moving between entries starts with a fresh log.
  return <QuestEntryPanel key={entryUuid} questUuid={questUuid} entryUuid={entryUuid} />;
};

export const Route = createFileRoute(
  "/gym/$venueUuid/loyalty/quests/$questUuid/entries/$entryUuid",
)({
  component: Component,
});
